// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"edce579f","539":"419585f7","787":"41f775f4","932":"64e3c61c"}[chunkId] + ".chunk.js";
};